import { DropdownOption } from "PFComponents/dropdown/dropdown";
import Select from "PFComponents/select/select";
import React, { useEffect, useRef, useState } from "react";

import { DoubleSectionPill, DoubleSectionPillProps } from "../double_section_pill";
import css from "./double_section_select_pill.module.scss";

const ARROW_WIDTH = 20;
const ARROW_LEFT_MARGIN = 4;

type DoubleSectionSelectPillProps = Omit<DoubleSectionPillProps, "rightContent"> & {
  attribute: JSX.Element | string;
  attributeOptions: DropdownOption[];
  onAttributeChange?: (newAttribute: DropdownOption["item"]) => void;
};

export const DoubleSectionSelectPill = ({
  attribute,
  attributeOptions,
  onAttributeChange,
  ...rest
}: DoubleSectionSelectPillProps) => {
  const widthIndicatorRef = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    setWidth(widthIndicatorRef?.current?.offsetWidth || 0);
  }, [attribute]);

  return (
    <DoubleSectionPill
      {...rest}
      rightContent={
        <span className={css.selectWrapper}>
          {/* Div below is used for calculating input width based on attribute width */}
          <div ref={widthIndicatorRef} className={css.attribute}>
            {attribute}
          </div>
          <Select
            // @ts-ignore
            kind="blank"
            readOnly
            controlledValue
            options={attributeOptions}
            handleChange={onAttributeChange}
            inputStyle={{
              width: width + ARROW_WIDTH + ARROW_LEFT_MARGIN,
              padding: 0,
              height: 32
            }}
            rootClassName={css.fixedHeight}
            classes={{
              inputField: {
                icon: css.selectIcon,
                root: css.fixedHeight,
                inputContainer: css.fixedHeight
              }
            }}
          />
        </span>
      }
    />
  );
};
